// extracted by mini-css-extract-plugin
export default {"loader":"_391mcxMw","pulseDot":"_2jv5c3NB","small":"_2gBqA3r5","large":"_3VG4YPMP","light":"_15-kA2FC","pulseDotLight":"_2duF95ip","dark":"_3pzwfhng","pulseDotDark":"_1-k8eSkD"};